import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { appsDashboardsOptions, dashboardSections, strCode } from "../../../consts";

import { PageSelector } from "../../../components";
import DashboardSections from "./DashboardSections";

const dashboardPages = [
  { id: dashboardSections.OVERVIEW, title: strCode.OVERVIEW },
  { id: dashboardSections.FIRMWARE, title: strCode.FIRMWARE },
  { id: dashboardSections.DIAGNOSTIC, title: strCode.DIAGNOSTIC },
  { id: dashboardSections.SETTINGS, title: strCode.SETTINGS },
  { id: dashboardSections.BATTERY_HEALTH, title: strCode.BATTERY_HEALTH }
];

const appsDashboardsOptionsKeys = {
  [strCode.OVERVIEW]: "OVERVIEW",
  [strCode.FIRMWARE]: "FIRMWARE",
  [strCode.DIAGNOSTIC]: "DIAGNOSTIC",
  [strCode.SETTINGS]: "SETTINGS",
  [strCode.BATTERY_HEALTH]: "BATTERY_HEALTH"
};

const Dashboard = ({ isMarketAdminOnly }) => {
  const [activePage, setActivePage] = useState(null);
  const groups = useSelector((state) => state.dashboardFilters.group);
  const apps = useSelector((state) => state.apps.apps);
  const appType = useSelector((store) => store.dashboardFilters.appType);

  useEffect(() => {
    const isActivePageAvailable = groups.some((group) => group.id === activePage);

    if (!isActivePageAvailable) {
      const page = dashboardPages.find((p) => groups.some((group) => group.id === p.id));

      if (page?.id) {
        setActivePage(page.id);
      }
    }
  }, [groups?.length]);

  const selectedAppTypes = useMemo(() => {
    return (apps || []).filter((app) => (appType || []).some((type) => type.id === app.appType));
  }, [apps, appType]);

  const dashboardPageOptions = useMemo(() => {
    return dashboardPages.filter((page) => {
      return groups.some((group) => {
        const hasGroup = group.id === page.id;

        const appHasGroup = selectedAppTypes.some((type) => {
          return type.availableDashboards?.some((dashboard) => {
            return appsDashboardsOptions[appsDashboardsOptionsKeys[page.id]]?.some(
              (d) => d.id === dashboard.name && dashboard.isSelected
            );
          });
        });

        return hasGroup && appHasGroup;
      });
    });
  }, [groups?.length, selectedAppTypes?.length]);

  return (
    <>
      {!isMarketAdminOnly && (
        <PageSelector
          setActivePage={setActivePage}
          activePage={activePage}
          pages={dashboardPageOptions}
        />
      )}

      <DashboardSections activePage={!isMarketAdminOnly ? activePage : null} />
    </>
  );
};

Dashboard.propTypes = {
  isMarketAdminOnly: PropTypes.bool.isRequired
};

export default Dashboard;
